import {cs}                 from "@Common/react/chain-services";

import {ReactGAGuestEvent}  from "@Common/libs/ga/xd-react-ga";
import {consumeContext}     from "@Common/react/context";
import {Invoke}             from '@Common/react/invoke';
import {Load2}              from '@Common/react/load2';
import {BubbleNoti}         from '@Common/ui-components/bubble-noti/bubble-noti';
import {cache0}             from '@Common/utils/cache0';

export const LoadFacebookAutoLogin = () => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("userLevels"),
    consumeContext("systemConstants"),
    ["load", ({systemConstants}, next) => (
        systemConstants.value && Load2({
            _key: JSON.stringify(systemConstants),
            fetch: () => loadFb(systemConstants.value?.FB_APP_ID),
            next
        })
    )],
    ["bubbleNoti", (_, next) => BubbleNoti({next})],
    ({apis, company, userLevels, load, bubbleNoti}) => (
        userLevels?.isGuest && !disableFacebookAutoLogin() && company?.prefs.enableMetaIdLogin && !load.loading && (
            document.cookie = "disable_facebook_auto_login=1; path=/",
            localStorage.getItem('jsonwebtoken') && Invoke({action: () => load.value?.login((response) => {
                if(response.authResponse) {
                    handleLogin({token: localStorage.getItem('jsonwebtoken'), apis, bubbleNoti})
                }
            })})
        )
    )
)

let disableOneTapPopup = null;
const disableFacebookAutoLogin = () => {
    if( disableOneTapPopup === null)
    {
        disableOneTapPopup = false
        document.cookie.split(';').forEach(pair => {
            if(pair.trim().startsWith('disable_facebook_auto_login'))
                disableOneTapPopup = pair.split('=')[1] === "1";
        })
    }
    return disableOneTapPopup
}

const handleLogin = async ({token, apis, bubbleNoti}) => {
    try {
        bubbleNoti.show({
            message: "Signing in... Please wait",
            color: "green",
            duration: 3000
        })
        let data = await apis.next.authenticate.facebookLogin({
            token
        })
        if( data.statusCode === "success" ) {
            ReactGAGuestEvent({
                eventName: "login",
                method: "Facebook",
                reason: data.message,
                statusCode: data.statusCode
            })
            location.reload()
        } else if( data?.data?.idUser ) {
            let data = await apis.next.authenticate.login({
                existingAccount: true,
            })
            if( data.statusCode === "success" ) {
                ReactGAGuestEvent({
                    eventName: "login",
                    method: "Facebook",
                    reason: data.message,
                    statusCode: data.statusCode
                });
                window.location.replace("/app");
            } else {
                ReactGAGuestEvent({
                    eventName: "login_failed",
                    method: "Facebook",
                    reason: data.message,
                    statusCode: data.statusCode
                }),
                bubbleNoti.show({
                    message: "Login Failed",
                    color: "red",
                    duration: 4000
                })
            }
        } else {
            bubbleNoti.show({
                message: "Login Failed",
                color: "red",
                duration: 4000
            }),
            ReactGAGuestEvent({
                eventName: "login_failed",
                method: "Facebook",
                reason: data.message,
                statusCode: data.statusCode
            })
        }
    } catch (error) {
        console.error(error);
    }
}

// cache to load only once ever
export const loadFb = cache0((appId) => new Promise<void>(resolve => {
    window.fbAsyncInit = function() {
        window.FB.init({
            appId            : appId,
            xfbml            : true,
            version          : 'v19.0',
            status           : true,
        });
        resolve(window.FB)
    }
    const script    = document.createElement("script");
    script.src      = "https://connect.facebook.net/en_US/sdk.js";
    script.async    = true
    script.id       = "facebook-jssdk"
    document.head.appendChild(script);
}));